import { ref } from "vue"
import _signupStepsCommonProps from "../../foundation/js/configurations/_signupStepsCommonProps"
import SignupStepActions from "../../../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepActions/SignupStepActions.vue"
import Tooltip from "../Tooltip/Tooltip.vue"

export default {
  name: "ContactStepCategoryContent",
  props: {
    ..._signupStepsCommonProps,
    fieldName: {
      type: String,
      required: true,
    },
    titleLabelKey: {
      type: String,
      required: true,
    },
    errorLabelKey: {
      type: String,
      required: true,
    },
  },
  components: {
    SignupStepActions,
    Tooltip,
  },
  setup(props) {
    const categories = ref(props.currentStepOptions)
    const categoryInput = ref(props.getNamedFieldInputData[props.fieldName]);

    return {
      categories,
      categoryInput,
      fieldName: props.fieldName,
      titleLabelKey: props.titleLabelKey,
      errorLabelKey: props.errorLabelKey,
    }
  },
}
